import ExemptionBanner from './ExemptionBanner';

export default ExemptionBanner;
